// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lCfnD","name":"styles_name__lF2j5","select":"styles_select__tmzaO","selectBtn":"styles_selectBtn__8gIyQ"};